import "components/shared/header/AppHeader.scss";

import AppHeaderNavbar from "components/shared/navigation/AppHeaderNavbar";
import ErrorComponent from "components/shared/error/Error";
import React from "react";
import { usePageFeedback } from "utils";

const AppHeader = (): JSX.Element => {
  const feedback = usePageFeedback();

  return (
    <header className="csa-app-header">
      <AppHeaderNavbar onSwitchAccountError={feedback.handleErrorWithMessage} />
      <ErrorComponent {...feedback.errorProps} autoScroll={false} />
    </header>
  );
};

export default AppHeader;
